module.exports = __webpack_public_path__ + "img/GR.abd7d677.svg";